import { createFileRoute } from '@tanstack/react-router';
import { FunctionCatalogPage } from '@/pages/organization/org-functions/OrgFunctionCatalogPage';
import { dataTableSearchSchema } from '@/lib/validation/dataTableSearchSchema';

export const Route = createFileRoute('/$slug/organization/functions/')({
  component: FunctionCatalogPage,
  validateSearch: dataTableSearchSchema({})
});
